import React from 'react'
import {
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
  Controller,
  Control,
} from 'react-hook-form'
import InfoIcon from '../../../../images/info_icon.png'
import { QuillEditor } from '../../../../components/form/inputs/QuillEditor'
import { FormField } from '../../../../components/form'
import { FormErrorMessage } from '../../../../constants/message'
import { EditFormData, SdgsTabData } from '../types'

// フォーム専用の型定義

interface SdgsEditTabProps {
  watch: UseFormWatch<EditFormData>
  setValue: UseFormSetValue<EditFormData>
  errors: FieldErrors<EditFormData>
  control: Control<EditFormData>
}

const SdgsEditTab: React.FC<SdgsEditTabProps> = ({
  watch,
  setValue,
  errors,
  control,
}) => {
  const handleQuillChange = (field: keyof SdgsTabData, value: string) => {
    setValue(`sdgs.${field}`, value)
  }

  return (
    <div>
      <div className="mt-6"></div>

      {/* 再生可能エネルギーの普及 */}
      <div className="pb-6">
        <FormField
          label="再生可能エネルギーの普及"
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.sdgs?.renewableEnergy?.message}
        >
          <Controller
            control={control}
            name="sdgs.renewableEnergy"
            rules={{
              maxLength: {
                value: 30000,
                message: FormErrorMessage.maxLength(30000),
              },
            }}
            render={({ field }) => (
              <QuillEditor
                value={field.value || ''}
                onChange={(value) => {
                  field.onChange(value)
                  handleQuillChange('renewableEnergy', value)
                }}
                placeholder="再生可能エネルギーの普及を入力してください"
              />
            )}
          />
        </FormField>
      </div>

      {/* 区切り線 */}
      <div className="border-b border-black mb-6"></div>

      {/* エネルギー効率化技術の開発 */}
      <div className="pb-6">
        <FormField
          label="エネルギー効率化技術の開発"
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.sdgs?.energyEfficiency?.message}
        >
          <Controller
            control={control}
            name="sdgs.energyEfficiency"
            rules={{
              maxLength: {
                value: 30000,
                message: FormErrorMessage.maxLength(30000),
              },
            }}
            render={({ field }) => (
              <QuillEditor
                value={field.value || ''}
                onChange={(value) => {
                  field.onChange(value)
                  handleQuillChange('energyEfficiency', value)
                }}
                placeholder="エネルギー効率化技術の開発を入力してください"
              />
            )}
          />
        </FormField>
      </div>

      {/* 区切り線 */}
      <div className="border-b border-black mb-6"></div>

      {/* 環境教育プログラムの実施 */}
      <div className="pb-6">
        <FormField
          label="環境教育プログラムの実施"
          labelClassName="text-xl font-bold mb-3"
          showTag={false}
          error={errors.sdgs?.environmentalEducation?.message}
        >
          <Controller
            control={control}
            name="sdgs.environmentalEducation"
            rules={{
              maxLength: {
                value: 30000,
                message: FormErrorMessage.maxLength(30000),
              },
            }}
            render={({ field }) => (
              <QuillEditor
                value={field.value || ''}
                onChange={(value) => {
                  field.onChange(value)
                  handleQuillChange('environmentalEducation', value)
                }}
                placeholder="環境教育プログラムの実施を入力してください"
              />
            )}
          />
        </FormField>
      </div>

      {/* 区切り線 */}
      <div className="border-b border-black mb-6"></div>

      <div className="border-l-4 border-main-green bg-main-lightgreen p-2 mt-2">
        <div className="flex items-center">
          <img src={InfoIcon} alt="Info" className="w-6 h-6 mr-6" />
          <div className="flex-1">
            <FormField
              label=""
              showTag={false}
              error={errors.sdgs?.sdgsInfo?.message}
            >
              <Controller
                control={control}
                name="sdgs.sdgsInfo"
                rules={{
                  maxLength: {
                    value: 30000,
                    message: FormErrorMessage.maxLength(30000),
                  },
                }}
                render={({ field }) => (
                  <QuillEditor
                    value={field.value || ''}
                    onChange={(value) => {
                      field.onChange(value)
                      handleQuillChange('sdgsInfo', value)
                    }}
                    placeholder="SDGs情報を入力してください"
                  />
                )}
              />
            </FormField>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SdgsEditTab
